import { render, staticRenderFns } from "./instance-service-config-form.view.vue?vue&type=template&id=602d15f1&scoped=true"
import script from "./instance-service-config-form.view.vue?vue&type=script&lang=ts"
export * from "./instance-service-config-form.view.vue?vue&type=script&lang=ts"
import style0 from "./instance-service-config-form.view.vue?vue&type=style&index=0&id=602d15f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602d15f1",
  null
  
)

export default component.exports